import React from "react";
import { Package, ShoppingBag, Tag, Layers, Star, Wallet, BarChart3 } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PermissionsKey } from "../../../../data/permissions";
import { RootState } from "../../../../redux/store";
import { useSelector } from "react-redux";

type Props = {
  storeId: number;
};

const StoreSections: React.FC<Props> = ({ storeId }) => {
  const { t } = useTranslation();

  const adminPermissions = useSelector((state: RootState) => state.admin.permissions);



  const sections = [
  {
    title: t("statistics"),
    icon: <BarChart3 size={24} />,
    link: `/admin/stores/${storeId}/statistics`,
    permission: PermissionsKey.ViewStoreStats,
  },
  {
    title: t("owner_sidebar.products"),
    icon: <Package size={24} />,
    link: `/admin/stores/${storeId}/products`,
    permission: PermissionsKey.ViewProduct,
  },
  {
    title: t("owner_sidebar.orders"),
    icon: <ShoppingBag size={24} />,
    link: `/admin/stores/${storeId}/orders`,
    permission: PermissionsKey.ViewStoreOrders,
  },
  {
    title: t("owner_sidebar.offers"),
    icon: <Tag size={24} />,
    link: `/admin/stores/${storeId}/offers`,
    permission: PermissionsKey.ViewOffer,
  },
  {
    title: t("categories"),
    icon: <Layers size={24} />,
    link: `/admin/stores/${storeId}/categories`,
    permission: PermissionsKey.ViewStoreCategory,
  },
  {
    title: t("owner_sidebar.Customers_Reviews"),
    icon: <Star size={24} />,
    link: `/admin/stores/${storeId}/reviews`,
    permission: PermissionsKey.ViewStoreReviews,
  },
  {
    title: t("owner_sidebar.Transactions"),
    icon: <Wallet size={24} />,
    link: `/admin/stores/${storeId}/transactions`,
    permission: PermissionsKey.ViewStoreTransactions,
  },
];

const filteredSections = sections.filter(
  (section) => !section.permission || adminPermissions.includes(section.permission)
);


  return (
    <>
    {
      filteredSections.length===0
      ?
      <div></div>
      :
      <div className="bg-white rounded-2xl shadow-custom-light p-6">
      <h2 className="text-xl font-semibold mb-4 text-Black capitalize">{t("store_sections")}</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {filteredSections.map((section) => (
          <Link
            to={section.link}
            key={section.title}
            className="flex flex-col items-center justify-center border rounded-xl p-4 hover:bg-primary/10 transition group"
          >
            <div className="text-primary group-hover:scale-110 transition-transform mb-2">
              {section.icon}
            </div>
            <span className="font-medium text-gray-700 capitalize">{section.title}</span>
          </Link>
        ))}
      </div>
    </div>
    }
    </>
  );
};

export default StoreSections;
